import * as ActionTypes from '../constants/action_types'
import * as utils from './utils'

// Actions associated with shortcuts (burner links)

// -----------------------------------------------------------------------------
// API Calls

function fetchShortcut (shortcutId) {
  return utils.makeApiCall({
    url: `/api/shortcuts/${shortcutId}`,
    actionRequest: ActionTypes.REQUEST_SHORTCUT,
    actionReceive: ActionTypes.RECEIVE_SHORTCUT,
    actionFailure: ActionTypes.REQUEST_SHORTCUT_FAILURE,
    authenticated: false,
    actionProps: {
      shortcutId
    }
  })
}

// -----------------------------------------------------------------------------
// Action Creators

// -----------------------------------------------------------------------------
// User invokable actions

export function fetchShortcutIfNeeded (id) {
  return (dispatch, getState) => {
    if (utils.shouldFetch(getState().shortcuts.byId[id])) {
      return dispatch(fetchShortcut(id))
    }
    return Promise.resolve()
  }
}

export function setShortcutAudiencePreference (topicId, preference) {
  return {
    type: ActionTypes.SHORTCUT_AUDIENCE_PREFERENCE,
    topicId,
    preference
  }
}